/** 隱私政策（繁體正文於此維護） */
export const privacyTitle = '隱私政策';

export const privacyBody =
`第 1 章 總則
（目的）
第 1 條 本規則旨在對 Japan DX 股份有限公司（以下簡稱「本公司」）於本會議中處理個人資料等相關基本事項予以規範。於遵守本規則之前提下，得就個人資料等之處理另行訂定細則。但本會議從業人員個人資料之處理，依另行規定辦理。
（定義）
第 2 條 本規則用詞定義如下：
（1）個人資料
指關於生存個人之資訊，且得以該資訊所包含之姓名、出生年月日及其他敘述等，識別特定個人者（包含得以輕易與其他資訊比對，進而識別特定個人之資訊）。
（2）個人資料檔案庫等
指包含個人資料之資訊集合，且符合下列情形者：
① 利用電腦將特定個人資料系統化建置，得以檢索之資訊集合；
② 除前款所列情形外，將資訊集合所包含之個人資料依一定規則整理，使特定個人資料得以輕易檢索之系統化資訊集合，且備有目錄、索引等便於檢索之相關內容者。
（3）個人資料
指構成個人資料檔案庫等之個人資料。
（4）保有個人資料
指本會議就該資料得為揭露、內容更正、補充或刪除、停止利用、銷毀及停止提供予第三人之全部個人資料，但下列情形除外：
① 因揭露該個人資料是否存在，將損及公共利益及其他利益者；
② 預定於 6 個月內銷毀者。
（5）當事人
指以個人資料識別之特定個人。
（個人資料保護總管等）
第 3 條
（1） 為統籌辦理個人資料保護相關措施之業務，應設置個人資料保護總管，由個人資料保護總管負責其事。
第 2 章 個人資料
（蒐集之原則）
第 4 條
（1） 個人資料應於事業、業務必要範圍內蒐集，並事先特定利用目的，於達成該目的必要限度內為之。
（2） 原則上不蒐集、利用或提供包含下列內容之個人資料：
有關思想、信念及宗教之事項；
有關種族、民族、門第、本籍（排除都道府縣）及其他可能招致社會歧視之事項。
（適正蒐集）
第 5 條 不得以詐欺及其他不正當手段蒐集個人資料。
（利用目的之公開或通知）
第 6 條
（1） 蒐集個人資料時，原則上應透過網站、機關刊物等公開下列事項：
利用目的；
個人資料提供予第三人相關事項；
個人資料共同利用相關事項。
（2） 未公開利用目的者，於蒐集個人資料時，應以書面或口頭向當事人通知其利用目的。但下列情形除外：
通知或公開利用目的，有損及當事人或第三人生命、身體、財產及其他權利利益之虞者；
通知或公開利用目的，有損及本會議權利或正當利益之虞者；
有配合國家機關或地方公共團體執行法令所定事務之必要，且通知或公開利用目的將妨礙該事務執行者；
依蒐集情形可認定利用目的顯而易見者。
（3） 第 1 項各款事項之訂定及變更，除微幅修正外，應經個人資料保護總管核准。
第 3 章 個人資料
（確保正確性）
第 7 條 應致力維持個人資料內容正確且為最新狀態。
（保存期間）
第 8 條 應就個人資料於達成利用目的必要範圍內訂定保存期間，於該保存期間屆滿或達成利用目的後，儘速予以銷毀。
（安全管理措施）
第 9 條
（1） 為防止個人資料外洩、滅失或毀損（以下簡稱「外洩等」），應採取下列措施：
技術管理措施：致力防範未經授權存取；
人員管理措施：確實向從業人員宣導，避免個人資料外洩等情事發生；必要時簽訂保密契約。
（2） 從業人員應致力事前防範，避免個人資料外洩等情事發生。
（受託者監督）
第 10 條 將個人資料處理業務委託外部者，應與受託者就保密事項、再委託事項及前條所定安全管理措施等內容簽訂契約。
（提供予第三人之限制）
第 11 條
（1） 將個人資料提供予第三人時，應事先以書面或口頭取得當事人明示同意。但下列情形除外：
依據法令規定者；
為保護他人生命、身體或財產有必要，且難以取得當事人同意者；
為提昇公共衛生或促進兒童健全成長尤有必要，且難以取得當事人同意者；
有配合國家機關、地方公共團體或其受託者執行法令所定事務之必要，且取得當事人同意將妨礙該事務執行者；
於達成利用目的必要範圍內委託處理個人資料者；
已依第 6 條第 1 項第 2 款規定，公開《個人資料保護法》第 23 條第 2 項所列事項者；
已依第 6 條第 1 項第 3 款規定，公開《個人資料保護法》第 23 條第 4 項第 3 款所列事項者。
（2） 將個人資料提供予第三人時，應事先向個人資料事務管理員申報，並經個人資料保護總管核准。但符合前項第 5 款情形、已採行前項第 6 款或第 7 款所定措施，及緊急情況者除外。
第 4 章 保有個人資料
（保有個人資料相關事項之公開等）
第 12 條
（1） 當事人請求通知得以識別其本人之保有個人資料之利用目的者，應儘速通知。但下列情形除外：
保有個人資料之利用目的顯而易見者；
符合第 6 條第 2 項第 1 款至第 3 款規定情形者。
（2） 依前項規定決定不予通知當事人所請求之保有個人資料利用目的者，應儘速將該決定通知當事人。
（揭露）
第 13 條
（1） 當事人請求揭露得以識別其本人之保有個人資料（無得以識別本人之保有個人資料時，應通知其事實，下同）者，應以書面或當事人同意之方式儘速揭露。但下列情形除外：
有損及當事人或第三人生命、身體、財產及其他權利利益之虞者；
有嚴重妨礙本會議業務適正執行之虞者；
違反其他法令規定者。
（2） 依前項規定決定對當事人請求之保有個人資料全部或部分不予揭露者，應儘速將該決定及依據條款通知當事人。
（3） 其他法令規定應以相當於本條第 1 項本文所列方式，向當事人揭露得以識別其本人之全部或部分保有個人資料者，不適用前項規定。
（更正等）
第 14 條
（1） 當事人以得以識別其本人之保有個人資料內容與事實不符為由，請求對該保有個人資料內容為更正、補充或刪除（以下簡稱「更正等」）者，應於達成利用目的必要範圍內，儘速辦理事實確認等必要調查，並依調查結果對保有個人資料內容為更正等處置。
（2） 依前項規定為更正等處置，或決定不予處置者，應儘速將相關情形（為更正等處置者，一併通知處置內容）通知當事人。
（停止利用等）
第 15 條
（1） 當事人以違反《個人資料保護法》第 16 條（利用目的之限制）或第 17 條（適正蒐集）規定為由，請求停止利用或銷毀保有個人資料，經查證請求有理由者，應於必要限度內儘速停止利用該保有資料等；難以執行者，應採取必要之替代措施以保護當事人權利利益。
（2） 當事人以違反《個人資料保護法》第 23 條（提供予第三人之限制）規定為由，請求停止將保有個人資料提供予第三人，經查證請求有理由者，應於必要限度內儘速停止將該保有資料提供予第三人；難以執行者，應採取必要之替代措施以保護當事人權利利益。
（3） 為前二項各項處置，或決定不予處置者，應儘速將相關情形通知當事人。
（理由說明）
第 16 條 依第 12 條第 2 項、第 13 條第 2 項、第 14 條第 2 項、前條第 3 項規定，就當事人請求之全部或部分措施，通知不予採行或採行不同措施者，應致力向當事人說明理由。
第 5 章 外洩等之對應
（發生外洩等時之對應）
第 17 條
（1） 從業人員知悉外洩等事實者，應儘速以口頭向個人資料事務管理員通報。
（2） 個人資料事務管理員應迅速調查確認事實關係，以防止二次災害、避免類似案件發生，並儘可能公開事實關係等；即便調查確認事實關係需耗費時間，亦應從防止二次災害之觀點公開外洩事實，致力恢復社會信賴。
（以上完）
`;
